export const notesRelationship = {
    collapsible: false,
    title: 'Notes',
    tint: 'note',
    type: 'notes',
};

export const notesRichTextRelationship = {
    collapsible: false,
    title: 'Notes',
    tint: 'note',
    type: 'richtext',
};
